import axios from "axios";

export async function removePupilFromTargetGroup(pupilId, groupId) {
    try {
        const response = await axios.delete(`/targetGroups/level2/${groupId}/pupils/${pupilId}`);
        return response.data;
    } catch (e) {
        const text = e.response?.data?.message || "Ошибка удаления ученика";
        throw new Error(text);
    }
}
